var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 11H1.5C1.295 11 1.125 10.83 1.125 10.625C1.125 10.42 1.295 10.25 1.5 10.25H11.5C11.705 10.25 11.875 10.42 11.875 10.625C11.875 10.83 11.705 11 11.5 11Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.375 2V11H7.625V2C7.625 1.45 7.4 1 6.725 1H6.275C5.6 1 5.375 1.45 5.375 2Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2 5V11H4V5C4 4.45 3.8 4 3.2 4H2.8C2.2 4 2 4.45 2 5Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 7.5V11H11V7.5C11 6.95 10.8 6.5 10.2 6.5H9.8C9.2 6.5 9 6.95 9 7.5Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.9118aaa5b5a8afa7231a011db5894a71.svg";
export { ForwardRef as ReactComponent };